import { render, staticRenderFns } from "./IntegracaoRndsAcoes.vue?vue&type=template&id=cb239494&scoped=true&"
import script from "./IntegracaoRndsAcoes.vue?vue&type=script&lang=js&"
export * from "./IntegracaoRndsAcoes.vue?vue&type=script&lang=js&"
import style0 from "./IntegracaoRndsAcoes.vue?vue&type=style&index=0&id=cb239494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb239494",
  null
  
)

export default component.exports